module.exports = __webpack_public_path__ + "static/img/aih.abaf5fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/aih.png
// module id = xCIV
// module chunks = 0